// TODO - remove lint disable when editing this file
/* eslint-disable */

export class ToHTMLConverterMiddleware {
  processStyle(content, style, block, context, nextCallback) {
    return nextCallback(content, style, block, context)
  }

  endStyles(content, context, nextCallback) {
    return nextCallback(content, context)
  }

  processEntity(content, entity, nextCallback) {
    return nextCallback(content, entity)
  }
}
